export const SKIP_CONVERSION_PATHS = new Set([
  "metadata.routing.path",
  "versions[].suites[].configurations[].name",
  "versions[].suites[].configurations[].shortSizeDescriptionInSquareFeet",
  "versions[].suites[].configurations[].shortSizeDescriptionInSquareMetres",
  "versions[].suites[].configurations[].verandaSizeInSquareFeet",
  "versions[].suites[].configurations[].verandaSizeInSquareMetres",
  "versions[].suites[].configurations[].configurationInformation",
  "versions[].suites[].configurations[].extraFeatures",
  "versions[].suites[].configurations[].cornerSuite",
  "source",
  "urlTarget",
  "covidProcedureLink",
  "royalOnePaymentBannerLink",
  "joinVsLink",
  "goToVsLink",
  "vsMemberBenefitsLink",
  "vsNotMemberLearnMoreLink",
  "royalOneBannerLink"
]);
